import React from 'react';

import StockPagePagination from '@/components/StockPagePagination';
import { PaginationWrapper } from '@/modules/CarsStock/components/common.styles';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import { getPage, getStockCarList, setPage } from '@/store/reducers/cars-stock';
import { handleScrollToCarsListHeader } from '@/modules/CarsStock/components/common.helpers';
import { pageLimit } from '@/modules/CarsStock/components/common.constants';

function Pagination() {
  const dispatch = useTypedDispatch();
  const page = useTypedSelector(getPage);
  const carListCount = useTypedSelector(getStockCarList)?.meta?.countAll;

  const handlePageClick = (page: number) => {
    handleScrollToCarsListHeader();
    dispatch(setPage(page));
  };

  const handlePageNext = () => {
    handleScrollToCarsListHeader();
    dispatch(setPage(page.currentPage + 1));
  };

  const handlePagePrev = () => {
    handleScrollToCarsListHeader();
    dispatch(setPage(page.currentPage - 1));
  };

  if (!carListCount || carListCount <= pageLimit) {
    return null;
  }

  return (
    <PaginationWrapper>
      <StockPagePagination
        itemsOnPage={pageLimit}
        page={page.currentPage}
        total={carListCount}
        onPageClick={handlePageClick}
        onPageNext={handlePageNext}
        onPagePrev={handlePagePrev}
      />
    </PaginationWrapper>
  );
}

export default Pagination;
